import repository from '@/repositories/Repository'

const resource = '/api/download_requests_pos'

export default {
  create(postData) {
    return repository.mouse.post(resource, postData).then(r => r.data)
  },
  get() {
    return repository.mouse.get(resource).then(r => r.data)
  },
  /**
   * 指定リクエストIDのクエリフィルタを取得
   *
   * @param {String} requestId リクエストID
   */
  getQueryFilter(requestId) {
    return repository.mouse
      .get(`${resource}/filter/${requestId}`)
      .then(r => r.data)
  },
  /**
   * 指定リクエストIDのダウンロードURLを取得
   *
   * @param {String} requestId リクエストID
   */
  getDownloadUrl(requestId) {
    return repository.mouse
      .get(`${resource}/url/${requestId}`)
      .then(r => r.data)
  },
  /**
   * 指定リクエストIDを削除する
   *
   * @param {String} requestId リクエストID
   */
  delete(requestId) {
    return repository.mouse.delete(`${resource}/${requestId}`).then(r => r.data)
  },
}
